/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Difficulty_Very_HardInputs */

const bn_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খুব কঠিন`)
};

const de_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehr schwer`)
};

const el_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πολύ δύσκολο`)
};

const en_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very hard`)
};

const es_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`muy duro`)
};

const fr_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Très difficile`)
};

const hi_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बहुत कठिन`)
};

const hu_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagyon kemény`)
};

const id_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sangat keras`)
};

const it_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molto difficile`)
};

const ja_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`とても難しい`)
};

const ko_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매우 단단함`)
};

const nl_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heel moeilijk`)
};

const pl_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bardzo ciężko`)
};

const pt_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muito difícil`)
};

const ru_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очень тяжело`)
};

const sv_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Väldigt hårt`)
};

const tr_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çok zor`)
};

const uk_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дуже важко`)
};

const vi_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rất khó`)
};

const zh_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非常难`)
};

const zh_hant_difficulty_very_hard = /** @type {(inputs: Difficulty_Very_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非常難`)
};

/**
* | output |
* | --- |
* | "Very hard" |
*
* @param {Difficulty_Very_HardInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const difficulty_very_hard = /** @type {((inputs?: Difficulty_Very_HardInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Difficulty_Very_HardInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_difficulty_very_hard(inputs)
	if (locale === "de") return de_difficulty_very_hard(inputs)
	if (locale === "el") return el_difficulty_very_hard(inputs)
	if (locale === "en") return en_difficulty_very_hard(inputs)
	if (locale === "es") return es_difficulty_very_hard(inputs)
	if (locale === "fr") return fr_difficulty_very_hard(inputs)
	if (locale === "hi") return hi_difficulty_very_hard(inputs)
	if (locale === "hu") return hu_difficulty_very_hard(inputs)
	if (locale === "id") return id_difficulty_very_hard(inputs)
	if (locale === "it") return it_difficulty_very_hard(inputs)
	if (locale === "ja") return ja_difficulty_very_hard(inputs)
	if (locale === "ko") return ko_difficulty_very_hard(inputs)
	if (locale === "nl") return nl_difficulty_very_hard(inputs)
	if (locale === "pl") return pl_difficulty_very_hard(inputs)
	if (locale === "pt") return pt_difficulty_very_hard(inputs)
	if (locale === "ru") return ru_difficulty_very_hard(inputs)
	if (locale === "sv") return sv_difficulty_very_hard(inputs)
	if (locale === "tr") return tr_difficulty_very_hard(inputs)
	if (locale === "uk") return uk_difficulty_very_hard(inputs)
	if (locale === "vi") return vi_difficulty_very_hard(inputs)
	if (locale === "zh") return zh_difficulty_very_hard(inputs)
	return zh_hant_difficulty_very_hard(inputs)
});